import axios from "axios";
import Joi from "joi";
import { includes, sum } from "lodash";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { useLocation, useParams } from "react-router-dom";
import { Price } from "../../components/__simple/_price";
import config from "../../configuration/config";
import Popup from "../../User/popup";
import ConfirmContext from "../../utils/confirmContext";
import { numberFormat } from "../../utils/currencyFormatter";
import { User_Data_Key, getData, saveData } from "../../utils/localStorageManager";
import { GetMessages, formValidate } from "../../utils/validation";
import useTrackBeginCheckout from "../../hooks/useTrackBeginCheckout";
import useTrackCompletesBookingVehicle from "../../hooks/useTrackCompletesBookingVehicle";
import { toast } from "react-toastify";
// import { Prompt } from "react-router-dom";
export function CarCheckoutReservationPage({ vehicle, parmActiveModel, isToyota, isLexus, selectedColor, finance, financeSettings, filterCarImages, ServiceParm }) {
  const { t: trans, i18n } = useTranslation(["new", "finance", "inputs", "info", "cart", "extra"]);
  let lang = i18n.language || "ar";
  const thisConfirmContext = useContext(ConfirmContext);
  const location = useLocation();
  const history = useHistory();

  const [showFinalPopupMessage, setShowFinalPopupMessage] = useState();
  const { slug, sn } = useParams();
  const [isLoadingSendOrder, setLoadingSendOrder] = useState(false);
  const [sadadInfo, setSadadInfo] = useState(null);
  const [carInfo, setCarInfo] = useState(null);
  const [activeModel, setActiveModel] = useState(parmActiveModel);
  const [dataFullNum, setDataFullNum] = useState(1);
  const [stepNum, setStepNum] = useState(1);
  const [dataFinalPopup, setDataFinalPopup] = useState({});
  const [showFinalPopup, setShowFinalPopup] = useState(false);
  const [showStstusLodingPopup, setShowStstusLodingPopup] = useState(false);
  const [requestForm, setRequestForm] = useState({ selectedNationality: "SAU" });

  const allowCustGroups = ["G4", "G3"];
  const query = new URLSearchParams(location.search);
  const [orderDraftID, setOrderDraftID] = useState(query.get("orderDraftID")?.trim());
  const [paymentType, setPaymentType] = useState(null);
  const [error, setError] = useState({});

  const schema_0 = Joi.object({});
  const schema_1 = Joi.object({
    name: Joi.string().required().messages(GetMessages()),
    phoneNumber: Joi.string().min(12).required().messages(GetMessages()),
    City: Joi.string().required().messages(GetMessages()),
    accountType: Joi.string().required().messages(GetMessages()),
    identity: Joi.string().min(10).required().messages(GetMessages()),
    commercialIdentity: Joi.string().min(10).required().messages(GetMessages()),
  });
  const schema_2 = Joi.object({
    OTP: Joi.string().required().min(4).messages(GetMessages()),
  });
  const schema_3 = Joi.object({
    paymentType: Joi.string().min(1).required().messages(GetMessages()),
  });
  const [propsData, setPropsData] = useState({});

  const [TotalTax, SetTotalTax] = useState(0);
  const [TotalDiscount, SetTotalDiscount] = useState(0);
  const [SumItemTotal, setSumItemTotal] = useState(0);
  const [SubTotal, setSubTotal] = useState(0);
  const [fullTotal, setfullTotal] = useState(0);
  const [MiniDownPayment, setMiniDownPayment] = useState(0);
  const [accountTypes, setAccountTypes] = useState([]);

  const [isClientAccount, setIsClientAccount] = useState(null);
  //-----------------------
  const [allServiceID, setAllServiceID] = useState([]);
  const [Service, setService] = useState(null);

  const [evaluations, setEvaluations] = useState({
    evaluation_false_0: 0,
    evaluation_false_1: 0.2,
    evaluation_false_2: 0.2,
    evaluation_false_3: 0.2,
    evaluation_true_0: 0.2,
  });

  const [allselectServices, setAllSelectServices] = useState([]);
  useEffect(() => {
    //اجراء التاكد من حالة الدفع وتحديث حقل isPayment
    //Site_Carts_PaymentStatus
    const fetchPaymentStatus = async () => {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var id = query.get("OrderGUID")?.trim();
      if (!id) return;

      setShowStstusLodingPopup(true);
      try {
        const response = await axios.post(`${config.controllURL}api/Payment/CarReservationPaymentStatus`, null, {
          headers: myHeaders,
          params: { ID: id },
          responseType: "json",
        });

        const responseData = response?.data;

        setShowStstusLodingPopup(false);

        if (!responseData) return;

        let data = Array.isArray(responseData) ? responseData.find((p) => p.Status === "success" || p.Status === "notPaid") || responseData[0] : responseData;

        if (!data) return;
        if (data.Status === "notPaid") {
          setShowFinalPopup(true);
          setShowFinalPopupMessage(trans("new:Payment_was_not_completed_Purchase_process_failed"));

          return;
        }

        if (data.Status === "success") {
          if (data?.SadadNumber) setSadadInfo(data.SadadNumber);
          setShowFinalPopup(true);
          setDataFinalPopup(data);
        } else if (data?.ResponseText) {
          try {
            const jsonData = JSON.parse(data.ResponseText);
            console.log("IsSuccess:", jsonData.IsSuccess);
            console.log("InvoiceStatus:", jsonData.Data?.InvoiceStatus);

            if (jsonData.IsSuccess == true && jsonData.Data?.InvoiceStatus) {
              setShowFinalPopup(true);
              setShowFinalPopupMessage(trans("new:Payment_was_not_completed_Purchase_process_failed"));
              data["InvoiceStatus"] = jsonData.Data?.InvoiceStatus;
              setDataFinalPopup(data);
            }
          } catch (error) {
            console.error("Invalid JSON:", error);
          }
        } else if (data?.ErrorMessage) {
          alert(`${data.ErrorMessage} / ${data?.ErrorProcedure || ""}`);
        }
      } catch (error) {
        console.error("Error fetching payment status:", error);
      }
    };

    // استدعاء الدالة عند الحاجة
    fetchPaymentStatus();
  }, []);


 //ارسال انه تم بدا اتمام الطلب الى منصة التسويق الخارجية
  useTrackCompletesBookingVehicle({orderData:dataFinalPopup,car:carInfo});

  useEffect(() => {
    var id = query.get("OrderGUID")?.trim();

    if (dataFinalPopup?.OrderId && id && sn && slug) {
      history.push({
        pathname: `/car/accessories/${sn}/${slug}`,
        search: `orderDraftID=${id}&isReservation=true`,
      });
    }
  }, [dataFinalPopup?.OrderId, slug, sn]);

  useEffect(() => {
    const parent = document.querySelector(".App");

    const handleScroll = () => {
      if (parent) {
        if (window.scrollY > 30) {
          parent.style.overflow = "visible"; // Enable when scrolling
        } else {
          parent.style.overflow = "hidden"; // Reset when at the top
        }
      }
    };

    // Attach scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (parent) {
        parent.style.overflow = ""; // Reset when unmounting
      }
    };
  }, []);
  const cachName = "checkoutCash_" + sn + "_" + slug;
  useEffect(() => {
    if (ServiceParm && ServiceParm.length > 0) {
      setService(ServiceParm);
    }
  }, [ServiceParm]);
  //-----------------------
  useEffect(() => {
    async function fetchData() {
      await handelGetCachData();

      axios
        .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteGetUserAccountTypes`, {})
        .then((response) => {
          //// console.log("accountType", response.data);
          setAccountTypes(response?.data?.filter((c) => allowCustGroups?.includes(c.ID)));
        })
        .catch((err) => {
          // console.log(err);
        });
      // ...
    }
    fetchData();
  }, []);
  const [platformTypes, setPlatformTypes] = useState([]);

  useEffect(() => {
    // تحميل الملف من مجلد public
    const loadManifest = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // Filter and map to extract keys with isActive = true
        var platformsTypes = data.platformsTypes || [];
        const activeKeys = platformsTypes.filter((platform) => platform.isActive).map((platform) => platform.key);

        // console.log("Active keys:", activeKeys);

        setPlatformTypes(activeKeys);
      } catch (error) {
        console.error("Error loading manifest.json:", error);
      }
    };

    loadManifest();
  }, []);

  var currentSize = 0;
  const CategoryCar = (Category) => {
    if (Size != currentSize) {
      currentSize = Category;
      SetSize(Category);
    }
  };
  const refrechDateCartItems = async (carInfo) => {
    Account(carInfo);
  };

  const handelSetRequestForm = useCallback(
    (newData) => {
      // console.log("handelSetRequestForm>>>>>>>>>>>>>>:", newData);
      // console.log("requestForm>>>>>>>>>>>>>>:", requestForm);
      setRequestForm((prevRequestForm) => ({
        ...prevRequestForm,
        ...newData,
      }));
    },
    [requestForm],
  );

  const [personalDataRequest, setPersonalDataRequest] = useState({
    arFirstName: "",
    arMiddleName: "",
    arLastName: "",
    enFirstName: "",
    enMiddleName: "",
    enLastName: "",
    genderID: "",
    address: "",
    cityID: "",
    countryID: "",
    logo: "",
  });
  const handelSetPersonalData = useCallback(() => {
    // You can await here
    const isLogin = getData("isAuthenticated");
    if (isLogin) {
      const userData = JSON.parse(getData(User_Data_Key, true));
      // console.log("userData>>>>>>>>>>>>>>>>:", userData);
      if (userData) {
        setPersonalDataRequest(userData);
        var name =
          lang == "ar"
            ? (userData?.arFirstName ?? "" + " " + userData?.arMiddleName ?? "" + " " + userData?.arLastName ?? "")
            : (userData?.enFirstName ?? "" + " " + userData?.enMiddleName ?? "" + " " + userData?.enLastName ?? "");
        userData["name"] = name;

        const val = {};
        val.name = name;

        const match = userData?.phone.match(/^(\+\d{1,4})(\d+)$/);

        const mainNumber = userData?.phone?.slice(-9); // Last 9 digits, e.g., 530005261
        // Get everything before the last 9 digits as the country code
        const countryCode = userData?.phone?.slice(0, -9);
        val.phoneNumberCode = countryCode.replace("+", "");
        val.phoneNumberOnly = mainNumber;
        val.phoneNumber = userData?.phone ? userData?.phone : "";
        val.accountType = userData?.custGroupID && allowCustGroups.includes(userData?.custGroupID) ? userData?.custGroupID : allowCustGroups[0];
        val.isClientAccount = val.accountType === "G4" ? true : false;
        setIsClientAccount(val.isClientAccount);
        val.identity = userData?.identity ? userData?.identity : "";
        val.commercialIdentity = userData?.tradeNo ? userData?.tradeNo : "";
        val.address = userData?.address ?? "";
        handelSetRequestForm(val);
      }
    } else {
      // history.push({
      //     pathname: `/car/checkout/${sn}/${slug}`,
      //     search: ""
      // });
      thisConfirmContext.onShowRegistrationPup(true);
    }

    // ...
  }, [allowCustGroups, handelSetRequestForm, lang, requestForm]);

  useEffect(() => {
    async function fetchData() {
      if (carInfo) {
        CategoryCar(carInfo?.groupID);
        await refrechDateCartItems(carInfo);
      }
      // ...
    }
    fetchData();
  }, [carInfo]);
  //Accounting for all items
  function Account(p) {
    p.quantity = 1;
    let currentTotalTax = (100 / 115) * ((p.MiniDownPayment ? p.MiniDownPayment : p.NetSalePrice) * p.quantity) * 0.15;

    SetTotalTax(currentTotalTax);

    let currentTotalDiscount = calculateDiscount(p);
    SetTotalDiscount(currentTotalDiscount);

    let currentSumItemTotal = (p.MiniDownPayment ? p.MiniDownPayment : p.NetSalePrice) * p.quantity;

    setSumItemTotal(currentSumItemTotal);
    let currentSumfullTotal = p.NetSalePrice * p.quantity;

    setfullTotal(currentSumfullTotal);
    let currentSubTotal = (p.MiniDownPayment ? p.MiniDownPayment : p.NetSalePrice) * p.quantity;
    setSubTotal(currentSubTotal);

    let currentMiniDownPayment = p.MiniDownPayment && p.MiniDownPayment != 0 ? p.MiniDownPayment * p.quantity : (p.MiniDownPayment ? p.MiniDownPayment : p.NetSalePrice) * p.quantity;
    setMiniDownPayment(currentMiniDownPayment);
  }
  // calculate discount
  const calculateDiscount = (itemInfo) => {
    let discountResult = [];
    try {
      if (couponDetail?.items) {
        //console.log(itemInfo);
        discountResult = couponDetail?.items.map((item) => {
          let result = 0;
          const { BrandID: brand, groupID, modelTypes, miniDownPayment, minPrice, quantity } = itemInfo;
          if (brand == item?.brandID && groupID === item?.productGroupID && modelTypes === item?.productModelTypeID) {
            result = getDiscountValueByType(item, minPrice, quantity);
          }

          return result;
        });
      }
    } catch (error) {
      //console.log(error);
    }
    return sum(discountResult) ?? 0;
  };

  //-----------------------------------------------
  const [couponDetail, setCouponDetail] = useState(null);

  // apply discount by type
  const getDiscountValueByType = (item, price, quantity) => {
    let result = 0;
    const { discountType, discountAmount, discountRate } = item;
    if (discountType?.toLowerCase() === "amount") {
      const discountValue = discountAmount * quantity;
      result = discountValue;
    } else if (discountType?.toLowerCase() === "rate") {
      const priceRateValue = price * quantity * (discountRate / 100);
      result = priceRateValue;
    }
    return result;
  };
  // useEffect(() => {
  //     handleFetchCountries();
  //     GetBranch();
  // }, []);
  useEffect(() => {
    //console.log("props:", propsData);
    var mm = {
      ...propsData,
      vehicle,
      isToyota,
      isLexus,
      selectedColor,
      finance,
      financeSettings,
      filterCarImages,
    };
    setPropsData(mm);

    var reservMiniDownPayment = (isToyota && isToyota) ? 2500 : isLexus ? 5000 : selectedColor?.MiniDownPayment;
    var newMiniDownPayment = selectedColor?.MiniDownPayment > reservMiniDownPayment ? reservMiniDownPayment : selectedColor?.MiniDownPayment;

    if (selectedColor) setCarInfo({ ...selectedColor, MiniDownPayment: newMiniDownPayment });
  }, [vehicle, isToyota, isLexus, selectedColor, finance, financeSettings, filterCarImages]);
  useEffect(() => {
    console.log("parmActiveModel:", parmActiveModel);
    setActiveModel(parmActiveModel);
  }, [parmActiveModel]);
  useEffect(() => {
    var id = query.get("OrderGUID")?.trim();
    if (id) return;
    // console.log("activeModel:", activeModel);
    if (activeModel && activeModel?.buyOnline != true) {
      setShowFinalPopupMessage(trans("new:chassisReserved"));
      setShowFinalPopup(true);
    }
  }, [activeModel]);

  const [Shipping, setShipping] = useState({ UnitTime: "", CountTime: 0, Cost: 0, CostWithTax: 0, DateTimeDelevry: "" });

  const [develviryType, setDeleviryType] = useState(2);
  const [Size, SetSize] = useState(0);

  useEffect(() => {
    async function fetchData() {
      // You can await here
      await checkStepsErrorsDataFullNum();
      // ...
    }
    fetchData();
  }, [requestForm, evaluations]);
  const cheangeSteps = async (step) => {
    if (
      step > 0 &&
      step <= 4 &&
      // && step < stepNum
      step != stepNum
    ) {
      const statusStep = await checkStepsErrors();
      if (statusStep >= step) {
        setStepNum(step);
      }
    }
  };

  //----------------------
  const [filteredCities, setFilteredCities] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const settingsResponse = await axios.request({
          baseURL: config.controllURL,
          url: lang + "/api/user/getSettings",
          method: "get",
        });

        if (settingsResponse.status === 200) {
          var mm = settingsResponse?.data?.genders.map((e) => {
            return { value: String(e.id), text: e.description };
          });

          setFilteredCities(
            settingsResponse?.data?.cities?.filter((item) => {
              return item.code == "SAU";
            }),
          );
        }
      } catch (err) {
        // console.log(err);
      }
      // ...
    }
    fetchData();
  }, [lang]);
  //-------------------------------------------
  const [cities, setCities] = useState([]);
  // to fetch all SAU countries
  const handleFetchCountries = async () => {
    let countries = [];
    try {
      const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_ShippingCities`, {});
      if (response.status == 200) {
        countries = response.data.map((item) => {
          return { value: item.ID, text: item[`${trans("model:description")}`] };
        });
      }
    } catch (error) {
      //console.log('error in fetching the countries of SAU', error);
    }
    setCities(countries);
  };
  //---------------------

  const checkStepsErrorsDataFullNum = async () => {
    var srempNumber = 0;

    var result = formValidate(schema_1, requestForm) ?? {};
    let otherProperities = [];
    let newErrors = {};
    const val = { ...requestForm };
    if (isClientAccount) {
      otherProperities = ["commercialIdentity"];
    } else {
      otherProperities = ["identity"];
    }
    newErrors = otherProperities ? removeUnspecificError(result, otherProperities) : result;

    if (Object.keys(newErrors).length === 0) {
      srempNumber = 1;
    } else {
      setDataFullNum(srempNumber);
      return srempNumber;
    }

    result = formValidate(schema_2, requestForm) ?? {};

    if (Object.keys(result).length === 0) {
      srempNumber = 3;
    } else {
      setDataFullNum(srempNumber);
      return srempNumber;
    }
    result = formValidate(schema_3, requestForm) ?? {};

    if (Object.keys(result).length === 0) {
      srempNumber = 4;
    } else {
      setDataFullNum(srempNumber);
      return srempNumber;
    }
    if (Object.keys(result).length === 0) {
      srempNumber = 4;
    } else {
      setDataFullNum(srempNumber);
      return srempNumber;
    }

    setDataFullNum(srempNumber);
    return srempNumber;
  };
  // to remove the unneeded props
  const removeUnspecificError = (errorList, values = []) => {
    let errorResult = {};
    if (values?.length > 0) {
      const lowerValues = values.map((item) => {
        return item.toLowerCase();
      });
      Object.assign(errorResult, errorList);
      if (errorList) {
        for (let index = 0; index < Object.keys(errorList).length; index++) {
          const key = Object.keys(errorList)[index];
          if (includes(lowerValues, key.toLowerCase())) {
            delete errorResult[key];
          } else {
            continue;
          }
        }
      }
    }
    return errorResult;
  };
  const checkStepsErrors = async (valForm = {}) => {
    var srempNumber = 0;

    var result = formValidate(schema_0, { ...requestForm, ...valForm }) ?? {};
    let otherProperities = [];
    let newErrors = {};

    if (stepNum == 1) setError(newErrors);

    if (Object.keys(newErrors).length === 0) {
      srempNumber = 1;
    } else {
      setDataFullNum(srempNumber);
      setStepNum(srempNumber + 1);
      return srempNumber;
    }
    result = formValidate(schema_2, { ...requestForm, ...valForm }) ?? {};
    // console.log("result222>>>>>>>>>>>>>>:", result);

    if (stepNum == 3) setError(result);

    if (Object.keys(result).length === 0) {
      srempNumber = 3;
    } else {
      setDataFullNum(srempNumber);
      setStepNum(srempNumber + 1);
      return srempNumber;
    }
    result = formValidate(schema_3, { ...requestForm, ...valForm }) ?? {};
    // console.log("result333>>>>>>>>>>>>>>:", result);
    if (stepNum == 4) setError(result);

    if (Object.keys(result).length === 0) {
      srempNumber = 4;
    } else {
      setDataFullNum(srempNumber);
      setStepNum(srempNumber + 1);
      return srempNumber;
    }

    if (stepNum == 4) setError(result);
    //console.log("result", result);
    if (Object.keys(result).length === 0) {
      srempNumber = 4;
    } else {
      setDataFullNum(srempNumber);
      setStepNum(srempNumber + 1);
      return srempNumber;
    }

    setDataFullNum(srempNumber);
    return srempNumber;
  };

  const handelSaveCachData = async (isClearAllServices = false) => {
    try {
      var cachData = {
        requestFormParm: requestForm,
        allServiceIDParm: isClearAllServices ? [] : allServiceID,
        allselectServicesParm: isClearAllServices ? [] : allselectServices,
        dataFullNumParm: dataFullNum,
        stepNumParm: stepNum,
        evaluationsParm: evaluations,
        isClientAccountParm: isClientAccount,
      };
      // console.log("handelSaveCachData>>>>>>>>>>>>>>>>>>>>>>>>:", cachData);
      saveData(cachName, cachData, true);
    } catch (error) {}
  };

  const handelGetCachData = useCallback(() => {
    try {
      const isLogin = getData("isAuthenticated");
      if (isLogin) {
        //// console.log("handelGetCachData>>>>>>>>>>>>>>>>>>>>>>>>:", cachName);
        const cachdataobject = getData(cachName, true);
        //// console.log("cachdataobject>>>>>>>>>>>>>>>>>>>>>>>>:", cachdataobject);
        const cachdata = JSON.parse(cachdataobject);
        //// console.log("cachdata>>>>>>>>>>>>>>>>>>>>>>>>:", cachdata);
        const { requestFormParm, allServiceIDParm, allselectServicesParm, dataFullNumParm, stepNumParm, evaluationsParm, isClientAccountParm } = cachdata;
        // console.log("cachdata>>>>>>>>>>requestFormParm>>>>>>>>>>>>>>:", requestFormParm);
        if (requestFormParm) {
          const val = { ...requestFormParm };
          val.OTP = null;
          handelSetRequestForm(val);
        }

        if (isClientAccountParm != null) setIsClientAccount(isClientAccountParm);

        if (allServiceIDParm) setAllServiceID(allServiceIDParm);

        if (allselectServicesParm) setAllSelectServices(allselectServicesParm);

        // if (dataFullNumParm) {
        //     var NewdataFullNumParm = dataFullNumParm > 2 ? 2 : dataFullNumParm
        //     setDataFullNum(NewdataFullNumParm);
        // }

        // if (stepNumParm) {
        //     var NewstepNumParm = stepNumParm > 2 ? 2 : stepNumParm
        //     setStepNum(NewstepNumParm);
        // }

        if (evaluationsParm) setEvaluations(evaluationsParm);
      }
    } catch (error) {
      console.warn(error.messages);
    }
    handelSetPersonalData();
  }, [requestForm]);

  //PaymentMAin
  async function handlePayment() {
    const isLogin = getData("isAuthenticated");
    if (isLogin) {
      const cleanData = JSON.parse(getData(User_Data_Key, true));
      //// console.log("handlePayment:", cleanData);
      const user_id = cleanData.id.toString().split("_")[1];
      handelSaveCachData();
      if (!isLoadingSendOrder) {
        //////console.log("handleSubmit:", requestForm);
        setLoadingSendOrder(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const { ipv4 } = await getUserIpAddress();

        let listofServices;
        // allServiceID
        var Product = [
          {
            id: carInfo?.ProductID,
            quantity: 1,
            colorID: carInfo?.ColorID,
            Type: 1,
            price: carInfo?.NetSalePrice,
            CartID: null,
            CostShipping: Shipping.Cost,
            VIN: carInfo?.SN,
            MiniDownPayment: carInfo?.MiniDownPayment ? carInfo?.MiniDownPayment : 5000,
          },
        ];

        var MethodPayment = "Myfatoorah";

        var raw = {
          URL: `${window.location.origin}/${lang}/car/reservation/${sn}/${slug}`,
          Lang: lang,
          Product: Product,
          Accessories: listofServices,
          NoteAccessories: null,
          UserID: user_id,
          City: requestForm.City,
          DelivaryAddress: null,
          NotificationWhatsApp: requestForm.NotificationWhatsApp == true ? 1 : 0,
          customerDetails: {
            IP: ipv4,
          },
          DataAmount: {
            FinalTotal: MiniDownPayment,
            AmountShipping: 0,
            SubAmountTotal: SubTotal,
            TotalTaxAmount: TotalTax,
            TotalDiscount: TotalDiscount,
            MiniDownPayment: MiniDownPayment,
          },
          PaymentAmount: MiniDownPayment,
          TypePaymnet: {
            IsReservation: 1,
            IsPayment: 1,
            PaymnetTypeID: MethodPayment == "Financing" ? "Credit" : "Cash", //Credit - Cash
            MethodPayment: MethodPayment,
          },
          DeliveryType: {
            ByBranch: null,
            ByLocation: null,
          },
          DeliveryData: {
            InfoBranch: null,
            InfoLocation: null,
          },
          CobonData: {
            Code: couponDetail?.coupon?.code ?? null,
            ID: couponDetail?.coupon?.id ?? null,
            Amount: couponDetail?.coupon?.CAmount,
          },
          RefrancePayment: null,
          InitializeOrder: false,
          InitializeOrderID: null,
          OrderDraftID: orderDraftID ? orderDraftID : null,
        };
        console.log("Payment", raw);
        // //test--------//
        // setDataInitializeOrder({
        //     OrderGUID: "847327E6-155F-49A7-ADC7-1C6C59D5635E",
        //     OrderId: "SO-2025-2225"
        // });

        // setCurrentStepIndex(1);

        // setTimeout(() => {
        //     handleFetchpdf("847327E6-155F-49A7-ADC7-1C6C59D5635E");
        // }, 1000);
        // setShowTimer(true);
        // return;
        // //test--------//
        axios
          .request({
            url: config.controllURL + "api/Payment/CarReservationPayment",
            headers: myHeaders,
            data: raw,
            method: "POST",
            responseType: "json",
          })
          .then(function (response) {
            //// console.log('response1', response);
            ////// console.log(response.data.URL_Payment);OrderId
            var responseData = null;
            if (response && response?.data && response?.data?.length > 0) {
              var dataRow = response?.data?.find((a) => a.OrderId != null);
              if (dataRow && dataRow.length > 0) {
                responseData = dataRow[0];
              } else {
                responseData = response?.data[0];
              }
            }

            //// console.log('responseData', responseData);
            var invoiceID = responseData?.SadadNumber;
            if (invoiceID) setSadadInfo(invoiceID);
            if (responseData?.URL_Payment) {
              window.location.href = responseData?.URL_Payment;
            } else if (responseData?.MessageError && responseData?.MessageError == "Duplicate Request") {
              window.location.href = `${window.location.origin}/${lang}/car/checkoutCash/${sn}/${slug}`;
            } else if (responseData?.OrderId && responseData?.ResponsMessage == "Paid") {
              setShowFinalPopupMessage(trans("new:paymentAlreadyMade"));
              setShowFinalPopup(true);
              setDataFinalPopup(responseData);
            } else if (responseData?.Message) {
              setShowFinalPopupMessage(responseData?.Message);
              setShowFinalPopup(true);
              setDataFinalPopup(responseData);
            } else {
              toast.error(trans("error:unknown_failure"));
            }

            setLoadingSendOrder(false);
          })
          .then((response2) => {
            //// console.log('response2', response2);

            setLoadingSendOrder(false);
          })
          .catch((error) => {
            //// console.log('error', error.messages)

            // alert(error.messages)

            setLoadingSendOrder(false);
          });
      }
    }
  }

  // to get info of current ipv4
  const getUserIpAddress = async () => {
    let currentIpv4Info = {};
    try {
      const response = await axios.get("https://geolocation-db.com/json/");
      if (response.status === 200) {
        const { IPv4, country_code, country_name } = response.data;
        currentIpv4Info.ipv4 = IPv4;
        currentIpv4Info.countryCode = country_code;
        currentIpv4Info.countryName = country_name;
      }
    } catch (error) {
      // toast.error(trans("extra:not_connection"))
      //// console.log(error);
    }
    return currentIpv4Info;
  };

  //ارسال انه تم بدا اتمام الطلب الى منصة التسويق الخارجية
  useTrackBeginCheckout({car:carInfo});
 
  return (
    <>
      {!showFinalPopup && (
        <section className="carOverview-page  nice-relative carCheckout-page flex flex-col ">
          <div className="nice-sticky-z-index show-xs">
            <div className="flex flex-col  nice-align-item-center   nice-shadow-1 bg-white w-100">
              <div className=" flex flex-row justify-between nice-align-item-center py-10 px-10   w-100 ">
                <img
                  className=" rotate-180"
                  src="/assets/icons/arrow-right.svg"
                  width="7"
                  height="7"
                  alt="arrow"
                  onClick={() => {
                    history.goBack();
                  }}
                />
                <span className="text-30">{trans("info:Cash_Car_Purchase")} </span>
                {!orderDraftID && (
                  <span
                    className=" text-24 text-gray"
                    onClick={() => {
                      history.push({
                        pathname: `/car/overview/${sn}/${slug}`,
                        search: "",
                      });
                    }}>
                    {trans("new:cancel")}{" "}
                  </span>
                )}
              </div>

              <div className="nice-shadow-2 bg-white w-100">
                <div className=" py-2 px-5 ">
                  {/* <div className="py-5 flex flex-row justify-between nice-align-item-center">
                                    <h3 className="text-30 text-bold ">{"تفاصيل الطلب"}</h3>

                                    
                                </div> */}

                  <div className="ruler-2 mb-5"></div>

                  <div className="carOverview-page-body flex flex-row justify-between nice-align-item-center">
                    {propsData?.vehicle ? (
                      <>
                        <div className="carOverview-page-body-desc">
                          <div className="carOverview-page-body-name">
                            <div className="carOverview-page-body-type ">
                              <div className="carOverview-page-body-type-content nice-gap-1rem">
                                <h2 className="text-20 text-bold">{propsData?.vehicle?.brand && propsData?.vehicle?.brand}</h2>
                                {/* <img src={vehicle?.brandIconPath && vehicle?.brandIconPath} /> */}
                                <img alt="" className="" src={`/assets/icons/brands/${(isToyota ? "toyota" : "") + (isLexus ? "lexus" : "")}.webp`} />
                              </div>
                            </div>

                            <h3 className="text-20 text-gray ">{activeModel?.modelDescription && activeModel?.modelDescription}</h3>
                            {carInfo ? (
                              <h3 className={"text-20 text-gray"}>
                                {carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[0] +
                                  " / " +
                                  carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[1]}
                              </h3>
                            ) : null}
                          </div>
                        </div>

                        <div
                          className="carOverview-page-body-img"
                          style={{
                            maxWidth: "70%",
                          }}>
                          {filterCarImages && filterCarImages[0] && <img className="carOverview-page-header-img" src={config.FilePathURL + filterCarImages[0]?.Image_URL} alt="" />}
                        </div>
                      </>
                    ) : (
                      <div className="container search-line my-40">
                        <h4 className="text-gray text-20 py-2">{trans("new:no_data")}</h4>
                      </div>
                    )}
                  </div>
                  <div className="ruler-2 mb-5"></div>
                  <div className="nice-container flex flex-col gap-3 justify-between">
                    <div className="flex flex-col justify-center">
                      {
                        <>
                          <div className="nice-flex nice-flex-row nice-flex-space-between mb-10">
                            <h4 className="text-20">
                              {trans("new:cash_price")}&nbsp;<span className="text-20 text-gray mx-1">{trans("new:total_include_tax")}</span>{" "}
                            </h4>
                            <span className="text-20 font-bold text-primary">{carInfo?.NetSalePrice && <Price price={parseFloat(carInfo?.NetSalePrice)} />}</span>
                          </div>
                          {allselectServices && allselectServices.length > 0 && (
                            <div className="nice-flex nice-flex-row nice-flex-space-between mb-10">
                              <h4 className="text-20">
                                {trans("new:accessories")}&nbsp;<span className="text-20 text-gray mx-1">{trans("new:total_include_tax")}</span>{" "}
                              </h4>

                              <div dir="ltr" className={"flex text-20 text-error font-bold"}>
                                {" "}
                                {allselectServices?.reduce((total, service) => total + service.Price, 0) ? (
                                  <>
                                    {" "}
                                    <Price price={allselectServices?.reduce((total, service) => total + service.Price, 0)} className={"white-space-pre"} />
                                    {" + "}{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          )}
                          {develviryType == 1 && (
                            <>
                              {Shipping.CountTime ? (
                                <div className="cart-grid-info-div ">
                                  <div className={"text-20 text-gray "}>
                                    {trans("cartFile:receive_peroid")} {" (" + trans("cartFile:After_issuing_the_plates") + ") "}
                                  </div>
                                  <div className={"text-20 text-gray font-bold"}>
                                    {Shipping.CountTime} <span className={"text-20 text-gray font-bold"}>{trans("cartFile:" + (Shipping.UnitTime ?? ""))}</span>{" "}
                                  </div>
                                </div>
                              ) : null}
                              {Shipping.CostWithTax ? (
                                <div className="cart-grid-info-div">
                                  <div className={"text-20 text-gray"}>{trans("cartFile:shipping_costs")}</div>
                                  <div className={"text-20 text-gray font-bold"}>{numberFormat(Shipping.CostWithTax, lang)}</div>
                                </div>
                              ) : null}
                            </>
                          )}
                        </>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="checkoutStepper nice-shadow-2 bg-white w-100 pt-10">
                <div className={"checkoutStepper-part " + (dataFullNum > 0 ? "active" : " ")} onClick={() => cheangeSteps(0)}>
                  <div className={`checkoutStepper-part-titel ${stepNum == 0 ? " active" : null}`}>
                    <span>{trans("new:الملخص")}</span>
                  </div>
                  <div className={"checkoutStepper-part-connector  "}></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="carOverview-page-content grid grid-cols-12 gap-5
                          justify-items-auto mx-30 mt-20">
            <div className="carOverview-page-main  h-vh border-radius col-span-12 md:col-span-8 sm:col-span-8 lg:col-span-7 xl:col-span-7">
              <div className="flex mb-10 hide-xs">
                {!orderDraftID && (
                  <div
                    className={"btn nice-flex-row border-radius nice-shadow-1 nice-border-checkout-gray  bg-white px-10  py-5  text-24 "}
                    onClick={() => {
                      history.push({
                        pathname: `/car/overview/${sn}/${slug}`,
                        search: "",
                      });
                    }}>
                    {trans("new:cancel")}{" "}
                  </div>
                )}
              </div>

              <div className=" px-20 carOverview-page-main nice-shadow-3 bg-white  h-vh border-radius col-span-12">
                <div className="flex flex-col py-20  px-10 ">
                  <div className="checkoutStepper hide-xs">
                    <div className={"checkoutStepper-part " + (dataFullNum > -1 ? "active" : " ")} onClick={() => cheangeSteps(1)}>
                      <div className={`checkoutStepper-part-titel ${stepNum == 1 ? " active" : null}`}>
                        <span>{trans("new:الملخص")}</span>
                      </div>
                      <div className={"checkoutStepper-part-connector  "}></div>
                    </div>
                  </div>

                  <form
                    className="flex flex-col  my-5 "
                    onSubmit={(e) => {
                      // submitRequest(e);
                    }}>
                    {stepNum == 1 && (
                      <>
                        <>
                          <div className="ruler-2 mt-20 mb-5"></div>

                          {
                            <div className="cart-grid-info-div ">
                              <div className={"text-20 font-bold text-black"}>
                                {activeModel?.modelDescription} {activeModel?.year}
                                &nbsp;<span className="text-20 text-gray mx-1">{trans("new:total_include_tax")}</span>
                              </div>
                              <div className={"text-20 text-black nice-space-nowrap text-primary font-bold"}>{numberFormat(fullTotal, lang)}</div>
                            </div>
                          }
                          {carInfo ? (
                            <div className="cart-grid-info-div ">
                              <div className={"text-20 text-gray"}>{trans("new:exterior_color") + " : " + carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[0]}</div>
                              <div className={"text-20 text-gray font-bold"}>{numberFormat(0, lang)}</div>
                            </div>
                          ) : null}
                          {carInfo ? (
                            <div className="cart-grid-info-div border-t">
                              <div className={"text-20 text-gray"}>{trans("new:interior_color") + ": " + carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[1]}</div>
                              <div className={"text-20 text-gray font-bold"}>{numberFormat(0, lang)}</div>
                            </div>
                          ) : null}
                          {develviryType == 1 && (
                            <>
                              {Shipping.CountTime ? (
                                <div className="cart-grid-info-div ">
                                  <div className={"text-20 text-gray "}>{trans("cartFile:receive_peroid")}</div>
                                  <div className={"text-20 text-gray font-bold"}>
                                    {Shipping.CountTime} <span className={"text-20 text-gray font-bold"}>{trans("cartFile:" + (Shipping.UnitTime ?? ""))}</span>{" "}
                                  </div>
                                </div>
                              ) : null}
                              {Shipping.CostWithTax ? (
                                <div className="cart-grid-info-div">
                                  <div className={"text-20 text-gray"}>{trans("cartFile:shipping_costs")}</div>
                                  <div className={"text-20 text-gray font-bold"}>{numberFormat(Shipping.CostWithTax, lang)}</div>
                                </div>
                              ) : null}
                            </>
                          )}

                          {TotalDiscount ? (
                            <div className="cart-grid-info-div ">
                              <div className={"text-20 text-gray"}>{trans("cartFile:discount_total")}</div>
                              <div className={"text-20 text-gray font-bold"}>{numberFormat(TotalDiscount, lang)}</div>
                            </div>
                          ) : null}

                          {allselectServices && allselectServices.length > 0 ? (
                            <div className="cart-grid-info-div ">
                              <div className={"text-20 font-bold text-black"}>
                                {trans("new:Total_Accessories")}&nbsp;<span className="text-20 text-gray mx-1">{trans("new:total_include_tax")}</span>
                              </div>
                              <div dir="ltr" className={"flex text-20 text-error font-bold"}>
                                {" "}
                                {allselectServices?.reduce((total, service) => total + service.Price, 0) ? (
                                  <>
                                    {" "}
                                    <Price price={allselectServices?.reduce((total, service) => total + service.Price, 0)} className={"white-space-pre"} /> {" + "}{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : null}

                          {develviryType == 1 ? (
                            <>
                              <div className="cart-grid-info-div border-tb">
                                <div className={"text-20 font-bold text-black"}>{trans("cart:total")}</div>
                                <div className={"text-20 text-black font-bold"}>
                                  {numberFormat(allselectServices?.reduce((total, service) => total + service.Price, 0) + fullTotal + Shipping.CostWithTax - TotalDiscount, lang)}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="cart-grid-info-div border-tb">
                              <div className={"text-20 font-bold text-black"}>{trans("cart:total")}</div>
                              <div className={"text-20 text-black font-bold"}>
                                {numberFormat(allselectServices?.reduce((total, service) => total + service.Price, 0) + fullTotal - TotalDiscount, lang)}
                              </div>
                            </div>
                          )}

                          {SubTotal && (
                            <div className="cart-grid-info-div">
                              <div className={"text-20 text-gray"}>{trans("cartFile:Downpayment")}</div>
                              <div className={"text-20 text-gray font-bold"}>{numberFormat(SubTotal, lang)}</div>
                            </div>
                          )}
                          {orderDraftID && SubTotal && (
                            <div className="cart-grid-info-div">
                              <div className={"text-20 text-gray"}>{trans("new:paid_amount")}</div>
                              <div className={"text-20 text-gray font-bold"}>{numberFormat(SubTotal, lang)}</div>
                            </div>
                          )}

                          {orderDraftID ? (
                            develviryType == 1 ? (
                              <>
                                <div className="cart-grid-info-div border-tb">
                                  <div className={"text-20 font-bold text-black"}>{trans("new:remaining_amount")}</div>
                                  <div className={"text-20 text-black font-bold"}>
                                    {numberFormat(allselectServices?.reduce((total, service) => total + service.Price, 0) + fullTotal + Shipping.CostWithTax - TotalDiscount - SubTotal, lang)}
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div className="cart-grid-info-div border-tb">
                                <div className={"text-20 font-bold text-black"}>{trans("new:remaining_amount")}</div>
                                <div className={"text-20 text-black font-bold"}>
                                  {numberFormat(allselectServices?.reduce((total, service) => total + service.Price, 0) + fullTotal - TotalDiscount - SubTotal, lang)}
                                </div>
                              </div>
                            )
                          ) : (
                            <div className="cart-grid-info-div border-tb">
                              <div className={"text-20 font-bold text-black"}>{trans("new:min_down_payment")}</div>
                              <div className={"text-20 text-black font-bold"}>{numberFormat(MiniDownPayment, lang)}</div>
                            </div>
                          )}
                        </>

                        <div className="my-10 ">
                          <div className="flex flex-col nice-gap-2rem">
                            <h3 className="text-gray text-20">{trans("new:avilable_platforms")}</h3>
                            <div className="breakout!! flex flex-col nice-gap-2rem ">
                              {platformTypes && platformTypes.includes("payTabs") && (
                                <div className={"flex flex-col nice-gap-2rem   " + (paymentType == "PayTabs&SADAD" ? " bg-gray-lighter " : "")}>
                                  <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                    {/* <input type='radio' checked={paymentType == "PayTabs&SADAD" ? true : false} name='paymentType'

                                                                        id="primary"
                                                                    /> */}
                                    {trans("new:online_batch") + " " + trans("new:and_the_rest_via_SADAD")}
                                  </label>
                                  <div className="flex flex-row items-center  mx-10">
                                    <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                                    <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                                    <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt={"mada"} />

                                    <img className="cart-payment-icon object-contain" src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                                  </div>
                                </div>
                              )}

                              {platformTypes && platformTypes.includes("myfatoorah") && (
                                <div className={"flex flex-col nice-gap-2rem border-radius p-5 " + (paymentType == "Myfatoorah&SADAD" ? " bg-gray-light " : "")}>
                                  <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                    {/* <input type='radio' checked={paymentType == "Myfatoorah&SADAD" ? true : false} name='paymentType'


                                                                        id="primary"
                                                                    /> */}
                                    {trans("new:online_batch") + " " + trans("new:and_the_rest_via_SADAD")}
                                  </label>
                                  <div className="flex flex-row items-center  mx-10">
                                    <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                                    <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                                    <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt={"mada"} />
                                    <img className="cart-payment-icon object-contain" src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <p className="text-20 text-gray text-bold text-inline-block mt-20">{trans("new:depositRefundableMessage")}</p>

                        <div className=" grid nice-align-item-center grid-cols-12 gap-5 justify-items-auto p-10   my-20 ">
                          <div className="border-box-periodic-checkInput col-span-12 md:col-span-7 sm:col-span-7 lg:col-span-7 xl:col-span-7"></div>

                          <div className="col-span-12 md:col-span-5 sm:col-span-5 lg:col-span-5 xl:col-span-5">
                            <div
                              className={"btn nice-flex-row  py-5 px-5 text-white text-30 " + (dataFullNum > -1 ? " bg-primary " : " bg-gray ")}
                              onClick={async () => {
                                handlePayment();
                              }}>
                              {isLoadingSendOrder && (
                                <span className="mx-2 loading-btn ">
                                  <img alt="" className="object-max-full " src="/assets/icons/loading.svg" width="25" height="25" />
                                </span>
                              )}

                              {orderDraftID ? trans("new:complete_purchase") : trans("info:Continue_to_Deposit_Payment")}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </form>
                </div>
              </div>
            </div>

            <div className=" hide-xs col-span-0  md:col-span-4 sm:col-span-4 lg:col-span-5 xl:col-span-5 ">
              <div className="carOverview-page-sub pt-20 nice-shadow-3 border-radius bg-white ">
                <div className=" py-10 px-5 ">
                  <div className="py-5">
                    <h3 className="text-30 text-bold ">{trans("new:orderDetails")}</h3>
                  </div>

                  <div className="ruler-2 mb-5"></div>
                  <div className="carOverview-page-body">
                    {propsData?.vehicle ? (
                      <>
                        <div className="carOverview-page-body-desc">
                          <div className="carOverview-page-body-name">
                            <div className="carOverview-page-body-type">
                              <div className="carOverview-page-body-type-content nice-gap-1rem">
                                <h2 className="text-20 text-bold">{propsData?.vehicle?.brand && propsData?.vehicle?.brand}</h2>
                                {/* <img src={vehicle?.brandIconPath && vehicle?.brandIconPath} /> */}
                                <img className="" src={`/assets/icons/brands/${(isToyota ? "toyota" : "") + (isLexus ? "lexus" : "")}.webp`} />
                              </div>
                            </div>

                            <h3 className="text-20 text-gray ">{activeModel?.modelDescription && activeModel?.modelDescription}</h3>
                            {carInfo ? (
                              <h3 className={"text-20 text-gray"}>
                                {carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[0] +
                                  " / " +
                                  carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[1]}
                              </h3>
                            ) : null}
                          </div>
                        </div>

                        <div className="carOverview-page-body-img">
                          {filterCarImages && filterCarImages[0] && (
                            <img
                              className="carOverview-page-header-img"
                              // src={"data:image;base64," + image.DATA}
                              src={config.FilePathURL + filterCarImages[0]?.Image_URL}
                              alt=""
                            />
                          )}
                        </div>
                      </>
                    ) : (
                      <div className="container search-line my-40">
                        <h4 className="text-gray text-20 py-2">{trans("new:no_data")}</h4>
                      </div>
                    )}
                  </div>
                  <div className="ruler-2 mb-5"></div>
                  <div className="nice-container flex flex-col gap-3 justify-between">
                    <div className="flex flex-col justify-center">
                      {
                        <>
                          <div className="nice-flex nice-flex-row nice-flex-space-between mb-10">
                            <h4 className="text-20">
                              {trans("new:cash_price")}&nbsp;<span className="text-20 text-gray mx-1">{trans("new:total_include_tax")}</span>{" "}
                            </h4>
                            <span className="text-20 font-bold text-primary">{carInfo?.NetSalePrice && <Price price={parseFloat(carInfo?.NetSalePrice)} />}</span>
                          </div>
                          {allselectServices && allselectServices.length > 0 && (
                            <div className="nice-flex nice-flex-row nice-flex-space-between mb-10">
                              <h4 className="text-20">
                                {trans("new:accessories")}&nbsp;<span className="text-20 text-gray mx-1">{trans("new:total_include_tax")}</span>{" "}
                              </h4>

                              <div dir="ltr" className={"flex text-20 text-error font-bold"}>
                                {" "}
                                {allselectServices?.reduce((total, service) => total + service.Price, 0) ? (
                                  <>
                                    {" "}
                                    <Price price={allselectServices?.reduce((total, service) => total + service.Price, 0)} className={"white-space-pre"} />
                                    {" + "}{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          )}

                          {develviryType == 1 && (
                            <>
                              {Shipping.CountTime ? (
                                <div className="cart-grid-info-div ">
                                  <div className={"text-20 text-gray "}>{trans("cartFile:receive_peroid")}</div>
                                  <div className={"text-20 text-gray font-bold"}>
                                    {Shipping.CountTime} {trans("cartFile:" + (trans("cartFile:" + (Shipping.UnitTime ?? "")) ?? ""))}
                                  </div>
                                </div>
                              ) : null}
                              {Shipping.CostWithTax ? (
                                <div className="cart-grid-info-div">
                                  <div className={"text-20 text-gray"}>{trans("cartFile:shipping_costs")}</div>
                                  <div className={"text-20 text-gray font-bold"}>{numberFormat(Shipping.CostWithTax, lang)}</div>
                                </div>
                              ) : null}
                            </>
                          )}
                        </>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <Popup show={showFinalPopup}>
        <div className="w-full  flex flex-column justify-center items-center">
          <div className="cart-finalized">
            <div className="cart-finalized-container flex flex-col">
              <div className="cart-finalized-container-img flex flex-col">
                <img alt="" src="/assets/images/finalized.svg" />
              </div>

              <div className="flex flex-wrap justify-center">
                <span className="text-20 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                <span className="text-20 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
              </div>

              {showFinalPopupMessage && (
                <>
                  <div className="flex mt-10 flex-wrap justify-center mx-20">
                    <span className="text-24 text-gray  mx-2"> {showFinalPopupMessage}</span>
                  </div>
                </>
              )}
              {dataFinalPopup?.InvoiceStatus && (
                <>
                  <div className="flex flex-wrap justify-center mx-20">
                    <span className="text-24 text-gray  mx-2"> {trans("new:حالة الدفع") + ":"}</span>
                    <span className="text-24 text-gray  mx-2"> {dataFinalPopup?.InvoiceStatus}</span>
                  </div>
                </>
              )}
              {dataFinalPopup && (
                <>
                  {
                    dataFinalPopup?.OrderId && (
                      <>
                        <div className="flex mt-5 flex-wrap justify-center mx-20">
                          <span className="text-20   mx-2"> {trans("new:quickBookingCompletedTitle")}</span>
                        </div>
                        {/* <div className="flex  flex-wrap justify-center mx-20">
                          <span className="text-24 text-gray  mx-2"> {trans("new:go_to_e_signature")}</span>
                        </div> */}
                        <div className="flex mt-2  flex-wrap justify-center mx-20">
                          <span className="text-20 text-gray  mx-2"> {trans("new:quickBookingCompletedDescription")}</span>
                        </div>
                      </>
                    )

                    // <div className="flex flex-row justify-center cart-finalized-code"
                    //     onClick={() => {

                    //         navigator.clipboard.writeText(dataFinalPopup?.OrderId);
                    //     }}

                    // >

                    //     <span className="text-20 font-bold text-white  mx-2"> {trans("info:order-number") + " :"}</span>
                    //     <span className="text-20 font-bold text-white  mx-2">{dataFinalPopup?.OrderId && dataFinalPopup?.OrderId}</span>
                    //     <img src="/assets/icons/copy.svg" alt='' />
                    // </div>
                  }
                </>
              )}

              {sadadInfo && (
                <>
                  <div className="flex mt-10  flex-wrap justify-center mx-20">
                    <span className="text-24 text-center text-gray  mx-2">
                      {" "}
                      {trans("new:a_payment_number_has_already_been_created") + " " + trans("new:to_avoid_order_cancellation") + " " + trans("new:within_24_hours")}
                    </span>
                  </div>

                  <div
                    className="flex cart-finalized-code flex-row nice-align-item-center"
                    onClick={() => {
                      navigator.clipboard.writeText(sadadInfo);
                    }}>
                    <div className=" bg-white border-radius p-1 ">
                      <img className=" object-contain" width={50} height={50} src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                    </div>
                    {
                      <div className="flex flex-row justify-center  mt-2">
                        {/* <span className="text-20 font-bold text-white  mx-2"> {trans("new:sadad") + " :"}</span> */}
                        <span className="text-20 font-bold text-white  mx-2">{sadadInfo}</span>
                      </div>
                    }
                    <img src="/assets/icons/copy.svg" alt="" />
                  </div>
                </>
              )}
              {/* <div className="flex flex-center flex-col  mt-5 pt-5 w-80">
                                <div className=" mb-5 w-100">
                                    <div className="nice-sm-btn cart-notification-go  bg-primary text-white text-20" onClick={() => {


                                        if (location.pathname)
                                            history.push("/");

                                    }}>
                                        {trans("cartFile:Continue_browsing")}
                                    </div>
                                </div>
                            </div> */}

              <div
                className="flex nice-flex-center  nice-align-item-center nice-flex-space-between w-100  gap-5 justify-items-auto 
                            py-10 px-20  my-10 ">
                {/* <div className="border-box-periodic-checkInput col-span-12 md:col-span-7 sm:col-span-7 lg:col-span-7 xl:col-span-7">
                  <div
                    className={"btn nice-flex-row  py-5 px-5 text-white text-24  bg-black"}
                    onClick={async () => {
                      if (location.pathname) history.push("/");
                    }}>
                    {trans("common:home")}
                    <div className={" mx-2 " + (lang == "ar" ? "  " : "rotate-180")}>
                      <svg height="15" width="20" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#ffffff" stroke="#ffffff">
                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M14.583 15v1h-7.083c-3.032 0-5.5-2.467-5.5-5.5s2.468-5.5 5.5-5.5h2.912l-2.646-2.646 0.707-0.707 3.853 3.853-3.853 3.854-0.707-0.708 2.646-2.646h-2.912c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5h7.083z"
                            fill="#000000"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div> */}
                <div className="col-span-12 md:col-span-5 sm:col-span-5 lg:col-span-5 xl:col-span-5">
                  <div
                    className={"btn nice-flex-row  py-5 px-5 text-white text-20 " + (dataFinalPopup && dataFinalPopup?.OrderId ? " bg-primary " : " bg-gray ")}
                    onClick={async () => {
                      if (dataFinalPopup && dataFinalPopup?.OrderId) history.push({ pathname: "/user/myBookings", search: "section=2" });
                      else {
                        history.push({
                          pathname: `/car/overview/${sn}/${slug}`,
                          search: "",
                        });
                      }
                    }}>
                    {dataFinalPopup && dataFinalPopup?.OrderId ? trans("new:goToCompleteOrder") : trans("new:Create_New")}
                    <div className={" mx-2 " + (lang == "ar" ? " rotate-180 " : "")}>
                      <svg xmlns="http://www.w3.org/2000/svg" height="15" width="20" viewBox="0 0 448 512">
                        <path
                          fill="#ffffff"
                          strokeWidth="2"
                          d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Popup>

      <Popup show={showStstusLodingPopup && !showFinalPopup}>
        <div className="w-full  flex flex-column justify-center items-center">
          <div className="cart-finalized">
            <div className=" flex flex-column justify-center items-center gap-5">
              <div className=" flex flex-col gap-3">
                <img src="/assets/Loding_new.svg" width={120} height={120} alt="Loding" />

                <span className="text-20 font-bold  text-primary mx-2 unselectable ">{trans("new:شكرًا لطلبك...!")}</span>
              </div>

              <div className="flex flex-wrap flex-column justify-center">
                {/* <span className="text-20 font-bold text-blackmx-2"> {trans("new:نقوم الآن بمعالجة الطلب،.")}</span> */}
                <span className="text-20 font-bold text-blackmx-2"> {trans("new: سيتم عرض رقم الطلب خلال لحظات.")}</span>
              </div>

              {showFinalPopupMessage && (
                <>
                  <div className="flex mt-10 flex-wrap justify-center mx-20">
                    <span className="text-24 text-gray  mx-2"> {showFinalPopupMessage}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
}
